<template>
  <div></div>
</template>

<script>
import Vue from 'vue';
import AppConfig from './../.env.js';

export default {
  name: 'Logout',
  mounted () {
    if (this.$store.getters['getUserType'].toLowerCase() === 'adviser') {
      this.$bus.$emit('send-activity-update');
    }

    this.$bus.$emit('user-logged-out');

    this.$http.post('/api/auth/logout').then(() => {
      delete Vue.prototype.$http.defaults.headers['X-Csrf-Token'];
      this.$store.commit('setUserID', 0);
      this.$store.commit('setUserEmail', '');
      this.$store.commit('setUserType', '');
      this.$router.push({ name: 'Logowanie' });

      if (AppConfig.isMobileApp) {
        window.localStorage.setItem('fincrm-app-token', '');
        Vue.prototype.$http.defaults.headers.Authorization = 'Bearer none';
      }
    }).catch((error) => {
      console.log(error);
      delete Vue.prototype.$http.defaults.headers['X-Csrf-Token'];
      this.$store.commit('setUserID', 0);
      this.$store.commit('setUserType', '');
      this.$router.push({ name: 'Logowanie' });

      if (AppConfig.isMobileApp) {
        window.localStorage.setItem('fincrm-app-token', '');
        Vue.prototype.$http.defaults.headers.Authorization = 'Bearer none';
      }
    });
  }
}
</script>
